const menuMessages = {
  myMembers: 'My Members',
  myProfile: 'My Profile',
  settings: 'Settings',
  signOut: 'Sign Out',
};

export default menuMessages;
